import { Model as e } from "../../../../model.js";
class r extends e {
  constructor(t) {
    super(), this.clientKey = t.clientKey, this.environment = t.environment, this.storedMethods = t.storedMethods, this.paymentMethods = t.paymentMethods;
  }
}
export {
  r as AdyenEngineConfigModel
};
//# sourceMappingURL=adyenEngineConfig.model.js.map
